<script>
export default {
  name: "LayoutsCatalog",

  created() {
    window.location = `${this.landingPageUrl}/katalog-badan/badania`;
  },
};
</script>
